import { render, staticRenderFns } from "./AccountSettingPermissions.vue?vue&type=template&id=8ab1f1a2&"
import script from "./AccountSettingPermissions.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ab1f1a2')) {
      api.createRecord('8ab1f1a2', component.options)
    } else {
      api.reload('8ab1f1a2', component.options)
    }
    module.hot.accept("./AccountSettingPermissions.vue?vue&type=template&id=8ab1f1a2&", function () {
      api.rerender('8ab1f1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingPermissions.vue"
export default component.exports